import { createActions } from 'redux-actions'

export const INIT_PRODUCTS_INFO = "INIT_PRODUCTS_INFO";

export const REQUEST_PRODUCTS_START = "REQUEST_PRODUCTS_START";
export const REQUEST_PRODUCTS_SUCCESS = "REQUEST_PRODUCTS_SUCCESS";
export const REQUEST_PRODUCTS_FAIL = "REQUEST_PRODUCTS_FAIL";

export const {

  initProductsInfo,
  requestProductsStart,
  requestProductsSuccess,
  requestProductsFail,

} = createActions({

  [INIT_PRODUCTS_INFO]: (req) => ({ req }),

  [REQUEST_PRODUCTS_START]: (req) => ({ ...req }),
  [REQUEST_PRODUCTS_SUCCESS]: (res) => ({ res }),
  [REQUEST_PRODUCTS_FAIL]: (res) => ({ res }),

})


